export type DeviceType = 'desktop' | 'mobile'

/** `desktop` | `mobile` — tablets report as mobile, as the dashboards have always split them. */
export const getDeviceType = (): DeviceType => (useDevice().isDesktop ? 'desktop' : 'mobile')
